import React from 'react';

const SkillsIcon = ({img, altImg}) => {
  return (
    <>
      <img className='logosSkills' src={img} alt={altImg} />
    </>
  );
};

export default SkillsIcon;
